import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="mx-auto max-w-4xl px-6 py-24 text-center"
      >
        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          Loading…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
